<template>
  <div class="share-card">
    <div class="share-header">
      <span class="share-header-spacer"></span>
      <span class="share-title">{{ $t('shareOn') }}</span>
      <button type="button" class="share-icon-btn" @click="$emit('close')">
        <v-icon size="16">mdi-close</v-icon>
      </button>
    </div>
    <div class="share-body">
      <div class="share-copy-field">
        <v-icon size="16" color="#5B6472">mdi-link-variant</v-icon>
        <input :id="`copy-link-${onlineAddress.id}`" :value="`${host}/${onlineAddress.code}`" class="share-copy-input" readonly/>
        <v-slide-x-transition hide-on-leave leave-absolute>
          <v-icon color="#00A876" size="20" v-if="onlineAddress.copy">mdi-check-circle</v-icon>
          <button type="button" class="share-icon-btn share-icon-btn-sm" @click="copyLink(onlineAddress)" v-else>
            <v-icon size="16" color="#0277BD">mdi-content-copy</v-icon>
          </button>
        </v-slide-x-transition>
      </div>

      <div class="share-option-row" v-for="(o, index) in $t('shareOptions')" :key="`share-option-${index}`">
        <span class="share-option-icon" :style="`background: ${o.color}1A; color: ${o.color};`">
          <v-icon size="18" :color="o.color">{{ o.icon }}</v-icon>
        </span>
        <span class="share-option-label">{{ o.description }}</span>
        <input :id="`copy-link-shared-on-${onlineAddress.id}-${o.value}`" :value="`${host}/${onlineAddress.code}?s=${o.value}`" class="share-hidden-input" readonly/>
        <div class="share-option-actions">
          <v-slide-x-transition hide-on-leave leave-absolute>
            <v-icon color="#00A876" size="18" v-if="o.copy">mdi-check-circle</v-icon>
            <button type="button" class="share-icon-btn share-icon-btn-sm" @click="copy(onlineAddress, o)" v-else-if="o.value != 'q'">
              <v-icon size="15" color="#5B6472">mdi-content-copy</v-icon>
            </button>
          </v-slide-x-transition>
          <button type="button" class="share-icon-btn share-icon-btn-sm" @click="share(o)">
            <v-icon size="15" color="#5B6472">mdi-open-in-new</v-icon>
          </button>
        </div>
      </div>

      <div class="share-qrcode-frame">
        <QRCodeMigly :value="`${host}/${onlineAddress.code}`" :enableControlls="true" width="120" border="0" :data="data" :logo="onlineAddress.user && onlineAddress.user.config && onlineAddress.user.config.picture && !!onlineAddress.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.name.includes('URL_SHORTNER')).filter(v => ['URL_SHORTNER_PRO', 'URL_SHORTNER_BUSINESS'].includes(v.subscriptionPlan.name))[0] ? onlineAddress.user.config.picture.src : null"/>
      </div>
    </div>
  </div>
</template>
<script>
import QRCodeMigly from './QRCodeMigly.vue';

  export default {
    name: 'ShareOptionsPanel',
    props: ['onlineAddress'],
    components: {
    QRCodeMigly
},
    data: () => ({
      host: null,
      data: {base64: null}
    }),
    mounted: function() {
      this.host = `${window.location.protocol}//${window.location.host.replace('www.', '')}`;
    },
    methods: {
      share(shareOption) {
        if(shareOption.value == 'q') {
          var w = window.open("");
          w.document.write(`<img src="${this.data.base64}"/>`);
        }else
          window.open(`${shareOption.url}${window.location.origin}/${this.onlineAddress.code}?s=${shareOption.value}`);
      },
      copyLink: function (item) {
        // Seleciona o texto do input
        var texto = document.getElementById(`copy-link-${item.id}`);

        // Seleciona o conteúdo do input
        texto.select();
        texto.setSelectionRange(0, 99999); // Para dispositivos móveis
        // Copia o texto para a área de transferência
        navigator.clipboard.writeText(texto.value)
          .then(() => {
            this.$commons.updateSnackbar({show: true, color: 'success', text: this.$t('copyLink')})
            item.copy = true
            this.$forceUpdate()
            setTimeout(() => {
              item.copy = false
              this.$forceUpdate()
            }, 3000);
          })
          .catch(err => {
            this.$commons.updateSnackbar({show: true, color: 'success', text: err})
          });
      },
      copy: function (item, o) {
        // Seleciona o texto do input
        var texto = document.getElementById(`copy-link-shared-on-${item.id}-${o.value}`);

        // Seleciona o conteúdo do input
        texto.select();
        texto.setSelectionRange(0, 99999); // Para dispositivos móveis
        o.copy = true
        // Copia o texto para a área de transferência
        navigator.clipboard.writeText(texto.value)
          .then(() => {
            this.$commons.updateSnackbar({show: true, color: 'success', text: this.$t('copyLink')})
            o.copy = true
            this.$forceUpdate()
            setTimeout(() => {
              o.copy = false
              this.$forceUpdate()
            }, 3000);
          })
          .catch(err => {
            this.$commons.updateSnackbar({show: true, color: 'success', text: err})
          });
      },
    },
  }
</script>
<style scoped>
input:focus {
    outline: none; /* Remove a borda padrão do navegador */
    border: none;  /* Remove a borda definida */
}
.share-card {
  width: 300px;
  max-height: 70vh;
  max-height: 70dvh;
  overflow-y: auto;
  background: #FFFFFF;
  border-radius: 1.25rem;
  font-family: 'Montserrat', sans-serif;
  box-shadow: 0 20px 40px rgba(16,24,39,0.14);
}
.share-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid rgba(16,24,39,0.06);
}
.share-header-spacer {
  width: 30px;
}
.share-title {
  flex: 1;
  text-align: center;
  font-weight: 800;
  font-size: 0.95rem;
  color: #101827;
}
.share-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: #E3F1FA;
  color: #5B6472;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  flex-shrink: 0;
}
.share-icon-btn:hover {
  background: #DDEBFA;
  transform: translateY(-1px);
}
.share-icon-btn-sm {
  width: 28px;
  height: 28px;
}
.share-body {
  padding: 1rem;
}
.share-copy-field {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #F7F5EF;
  border-radius: 999px;
  padding: 0.55rem 0.9rem;
  margin-bottom: 0.85rem;
}
.share-copy-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  color: #101827;
  font-weight: 600;
  font-size: 0.85rem;
}
.share-option-row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.55rem 0;
}
.share-option-row + .share-option-row {
  border-top: 1px solid rgba(16,24,39,0.06);
}
.share-option-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
}
.share-option-label {
  flex: 1;
  font-weight: 700;
  font-size: 0.85rem;
  color: #101827;
}
.share-hidden-input {
  position: absolute;
  width: 0;
  height: 0;
  border: none;
  opacity: 0;
  pointer-events: none;
}
.share-option-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}
.share-qrcode-frame {
  display: flex;
  justify-content: center;
  background: #F7F5EF;
  border-radius: 1rem;
  padding: 1rem;
  margin-top: 0.75rem;
}
</style>
